import { useCallback } from 'react';
import { useOpenDeeplink } from '../../../../hooks';
import {
  appendParams,
  finalizeUrl,
  getDefaultDeeplink,
} from '../../utils';

interface MoveToEditGoodsLikeParams {
  /** 진입 직전 LikeGoods 화면의 카테고리 sno (`-1`/null이면 '전체'). */
  categorySno?: number | null;
  /** 진입 직전 오늘출발 토글 상태. */
  isDeliveryFilterOn?: boolean;
  /** 진입 직전 정렬 키. */
  order?: string | null;
}

/**
 * 찜한 상품 편집 화면으로 이동.
 * `ably://react/App?screen=EditGoodsLike&extras={...}` 형태 딥링크로 호출되어
 * `Navigator.tsx` 의 `convertParams` 가 extras 를 파싱해 route param 으로 주입.
 */
export const useMoveToEditGoodsLike = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(
    ({
      categorySno,
      isDeliveryFilterOn,
      order,
    }: MoveToEditGoodsLikeParams = {}) => {
      // Navigator.convertParams 가 snake_case 로 읽으므로 동일 형태로 보존
      const extras = {
        ...(categorySno != null ? { category_sno: categorySno } : {}),
        ...(isDeliveryFilterOn !== undefined
          ? { is_fast_delivery: isDeliveryFilterOn }
          : {}),
        ...(order != null ? { order } : {}),
      };

      const url = getDefaultDeeplink();
      appendParams(url, 'screen', 'EditGoodsLike');
      appendParams(url, 'extras', JSON.stringify(extras));

      openDeeplink(finalizeUrl(url));
    },
    [openDeeplink],
  );
};
